// extracted by mini-css-extract-plugin
export default {"wrapper":"snackbar_wrapper--suBhj","show":"snackbar_show--hNCwO","opened":"snackbar_opened--PKFHV","closing":"snackbar_closing--olANr","content":"snackbar_content--jQsAb"};